const CASE_STATUS: Record<string, string> = {
  AWAITING_WHATSAPP: 'Awaiting WhatsApp',
  WHATSAPP_CONNECTED: 'WhatsApp connected',
  READY_FOR_FOLLOWUP: 'Ready for follow-up',
  MANUAL_REVIEW: 'Manual review',
  CANCELLED: 'Cancelled',
};

const OUTCOME: Record<string, string> = {
  PENDING: 'Pending',
  CUSTOMER_CONFIRMED: 'Customer confirmed',
  NOT_YET: 'Not yet',
  PROBLEM_REPORTED: 'Problem reported',
  UNREACHABLE: 'Unreachable',
  MANUAL_REVIEW: 'Manual review',
  AUTO_CONFIRMED_TIMEOUT: 'Verified after confirmation window',
};

const COMMISSION_STATUS: Record<string, string> = {
  PENDING: 'Pending',
  VERIFIED: 'Verified',
  PAYABLE: 'Payable',
  PAID: 'Paid',
  CANCELLED: 'Cancelled',
};

export function managedCaseStatusLabel(status: string | null | undefined): string {
  if (!status) {
    return '';
  }
  return CASE_STATUS[status] || status;
}

export function verificationOutcomeLabel(outcome: string | null | undefined): string {
  const key = outcome || 'PENDING';
  return OUTCOME[key] || key;
}

export function commissionStatusLabel(status: string | null | undefined): string {
  const key = status || 'PENDING';
  return COMMISSION_STATUS[key] || key;
}
